export const articlesPostdocs = [

  'Recognition',
  'Appointments',
  'Benefits',
  'Child care',
  'Compensation',
  'Discipline and dismissal',
  'Grievance and arbitration procedures',
  'Health and safety',
  'Housing',
  'Holidays',
  'Immigration',
  'Individual development plans and progress assessments',
  'International scholar and immigrant support',
  'Job abandonment',
  'Labor management meetings',
  'Lawrence Berkeley National Lab article',
  'Layoff',
  'Leaves of absence',
  'Management and academic rights',
  'Medical separation',
  'No strikes',
  'Nondiscrimination',
  'Parking and transit',
  'Past practices',
  'Personal time off',
  'Personnel files',
  'Posting',
  'Professional development and career counseling',
  'Progress assessments',
  'President\'s postdoctoral fellowships',
  'Reasonable accommodation',
  'Relocation reimbursement',
  'Respectful work environment',
  'Respect is a part of research training',
  'Severability',
  'Sick leave',
  'Successorship',
  'Time and effort commitment',
  'Titles and classifications',
  'Training',
  'Travel reimbursement',
  'Union access and rights',
  'Union security',
  'University facilities and services',
  'Voluntary resignation',
  'Waiver',
  'Work authorization',
  'Work-incurred injury and illness',
  'Workspace and materials',
  'Duration',
  'Health benefits side letter',
  'Compensation side letter',
  'Transit side letter',
  'Joint labor management committee side letter',
  'Appendix A',
  'Appendix B',
  'Appendix C',
  'Appendix F',
  'Appendix G',
  'Appendix H',
  'Ground rules',
  'Extension of previous contract',
];

// Instantiate a list of dictionaries for each article, appendix or side letter here.

const recognitionProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const appointmentsProposals = [
  // {
  //   name: 'Proposal | UC to UAW | Aug. 17, 2021',
  //   link: 'https://drive.google.com/file/d/10dqw-RuCf56cxYm_iRbOw5wOk56BzLsZ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 9, 2021',
  //   link: 'https://drive.google.com/file/d/12X7NjtH8ZTI90r5mQOIp_xllivR6rESk/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 8, 2021',
  //   link: 'https://drive.google.com/file/d/1vHzuVRMmQ94bn11Zczkuns_j5vHkYzlr/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/15-Gc2SPyHq6MINEmOnSf1lw2ZGZ8pjg0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | May 4, 2022',
  //   link: 'https://drive.google.com/file/d/1xXrZglJs2qkYrFfUI73ZPsTjTnIbsunH/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | June 2, 2022',
  //   link: 'https://drive.google.com/file/d/1P780SLDTcLI4lRHvqIaFPEtKZz0s-vxx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/1cjKQDNvW8KJpLc_8tZ2xYk05VD7U_kSd/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 25, 2022',
  //   link: 'https://drive.google.com/file/d/1RPrzVGzTwGGOB2_HcR9S56Y6Lw28viwd/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1XWuJevYrcD-6rnMjXFJIpGM1IaxyYoq-/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1-eSPkf56pgun1cGXyEfqOVVtXj4xqhK5/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1Mtoar_LrDwNVIAzBLh3pBHGHyezrKROP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 11 , 2022',
  //   link: 'https://drive.google.com/file/d/17bdKktjZPvIBcc8WLiRJANFHVlt1g_B2/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11 , 2022',
  //   link: 'https://drive.google.com/file/d/1GeAqFvV0MFUYxxbAWXm8So6c0qr-vmGP/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13 , 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Supposal | UC to UAW | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/176lSmk0bNAu5jJzJpBDDvxtU8_-qi-s8/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Supposal | UAW to UC | Nov. 20, 2022',
  //   link: 'https://drive.google.com/file/d/1w13LQoVeYRgw1KjATsGszamL21h1b5GF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/11Ri3hjGjwxxhGqnstUkphE4nHbxW1zIw/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1YU3Acospv5nA4UKoKlvK0Ofq982Nr0SJ/view?usp=sharing',
    color: 'success',
  },
];

const benefitsProposals = [
  {
    name: 'Tentative agreement | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1yEtPW_YapHEc-jn-rJCxDqakjfcT7s7X/view?usp=share_link',
    color: 'success',
  },
];

const childCareProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 11, 2021',
  //   link: 'https://drive.google.com/file/d/159cba0Lf0RxSm7slEWiSgJKbrBaSip6E/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 3, 2022',
  //   link: 'https://drive.google.com/file/d/1s0jhGoH8e7q4tr_4vvlnA0pD49N4MJw-/view?usp=sharingg',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Sept. 27, 2022',
  //   link: 'https://drive.google.com/file/d/17DNdgDHqclBAQR84czgBnVsuhYtcP9Cl/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Sept. 27, 2022',
  //   link: 'https://drive.google.com/file/d/1hzxQ_7vNSUVn26kUMYCfLXdsRq-kDMl4/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1WFLWqIUVklYEut5ockuXJ-bxRncoWdvT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1cPj_BI9ypu3D1BckJo9R1zCYu41aCCtI/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1rnb6DTqouYLBeZPYwAEF4bZ4vWD_XDyv/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/1VI7axH4bRhi0FoSrGYwpmrLbjEeLV91L/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/18vzvLwgPie26b4hHCIy8tDlBsCLW6lu6/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1al7u0XgDKtyOJLBvKwKQCDm-9swfvwlw/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1OYvzTIPMdYdwzJ6STN29NHkKoZCJxLbw/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1b4wcwH1lsM9iRvDt3ApQwQ-K43tPq7pf/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1ehcROGJxXYQ7qZ9dH-P3D5ZvWLAOT2Zt/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1J7DYTGiMx189c153oT0CsO7Zdfml53Bl/view',
    color: 'success',
  },
];

const compensationProposals = [
  {
    name: 'Proposal | UAW to UC | Aug. 2, 2021',
    link: 'https://drive.google.com/file/d/1vEUmhrMiLXNvW_5hwxP8Y62PPMtouvke/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Aug. 25, 2021',
    link: 'https://drive.google.com/file/d/1Eys_UleUB2OAw9W_Fsqy_at308Cibs-P/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Oct. 5, 2021',
    link: 'https://drive.google.com/file/d/14jB3GKT0JzuO2WBYLOtC-EGPK8uInQGs/view',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Oct. 5, 2021',
    link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | June 23, 2022',
    link: 'https://drive.google.com/file/d/1gDr6dH2y71Sax60IvG-57rPO1nkOV7Vq/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | June 23, 2022',
    link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | July 14, 2022',
    link: 'https://drive.google.com/file/d/1dmTNcFI7dxc9gQWcQLWKaYdjj_GmHYMc/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Sept. 27, 2022',
    link: 'https://drive.google.com/file/d/10Iiqe6UvmwaCm5wWfQmqo9tDbMWnN8Ce/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Sept. 27, 2022',
    link: 'https://drive.google.com/file/d/1hzxQ_7vNSUVn26kUMYCfLXdsRq-kDMl4/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Oct. 10, 2022',
    link: 'https://drive.google.com/file/d/1nrRf0kTJFGVP3axwiVdv1EI0Ri4vYyLS/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Oct. 10, 2022',
    link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 1, 2022',
    link: 'https://drive.google.com/file/d/1n5RK5F6_gZU3WcO3DQnTnc-N4zs1cSNF/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 1, 2022',
    link: 'https://drive.google.com/file/d/1rnb6DTqouYLBeZPYwAEF4bZ4vWD_XDyv/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1rYttF65_dHizJSNCzY2qK6xaq1xyoBgY/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1hNJRUty8YhSM8J6tzMSSUA83aLoJVb2x/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Nov. 13, 2022',
    link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Nov. 23, 2022',
    link: 'https://drive.google.com/file/d/1SMPi2wOB5I94SIdD0xgQbQD2_hPZAeiv/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Nov. 23, 2022',
    link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1YKs8pPnvuBwbZzfwZCx8mnKvZbjVqYen/view?usp=sharing',
    color: 'success',
  },
];

const disciplineProposals = [
  {
    name: 'Tentative agreement | Sept. 13, 2021',
    link: 'https://drive.google.com/file/d/1WgQ1HCntgUSQSVLRMqO8Djd-d-EdJ6-Q/view?usp=sharing',
    color: 'success',
  },
];

const grievanceProposals = [
  {
    name: 'Tentative agreement | Sept. 27, 2022',
    link: 'https://drive.google.com/file/d/1OpsnaJIwKCcvWde_f4jTAzg_kBAW9nuS/view?usp=sharing',
    color: 'success',
  },
];

const healthSafetyProposals = [
  {
    name: 'Tentative agreement | Oct. 21, 2021',
    link: 'https://drive.google.com/file/d/1agOJCgmuBRmG1I70ZXQhSyFKe0zW5k-A/view?usp=share_link',
    color: 'success',
  },
];

const housingProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 25, 2021',
  //   link: 'https://drive.google.com/file/d/1Iy60PEqw2BP7KX4569cqc1V-Sqa7Qqyu/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1WN2vo5yWK5aHfF13bkwFN4ouKwhpKXc4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const holidaysProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1_XzA8dlOLDViETGalmCtyZTBIfhJyGaf/view',
    color: 'success',
  },
];

const immigrationProposals = [
  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1lidcVZn2i64tH9V5sJNFQmtkb3o-gNoX/view?usp=share_link',
    color: 'success',
  },
];

const individualDevelopmentProposals = [
  {
    name: 'Tentative agreement | Feb. 21, 2022',
    link: 'https://drive.google.com/file/d/1PMczmCqBqDG_H-czpvoLKRDE8k1ots9K/view?usp=sharing',
    color: 'success',
  },
];

const internationalScholarProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Sept. 9, 2021',
  //   link: 'https://drive.google.com/file/d/18ObJiNqhJi0ZNyTbXbKDaNbbrh3vxsZG/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 21, 2021',
  //   link: 'https://drive.google.com/file/d/1KDsTZQs3ISSjYBZKTtbSUps1P7iIFQqB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/15-Gc2SPyHq6MINEmOnSf1lw2ZGZ8pjg0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | June 2, 2022',
  //   link: 'https://drive.google.com/file/d/1P780SLDTcLI4lRHvqIaFPEtKZz0s-vxx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sept. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1UDhWr3pJgzrKxAeximDDN89_jJQxEjJx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const jobAbandonmentProposals = [];

const laborManagementProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const LBNLProposals = [
  {
    name: 'Tentative agreement | Nov. 22, 2022',
    link: 'https://drive.google.com/file/d/1J7UkE9combxSV4dK_Ze_B1b9zwh_8w4p/view?usp=share_link',
    color: 'success',
  },
];

const layoffProposals = [
  // {
  //   name: 'Proposal | UC to UAW | July 30, 2021',
  //   link: 'https://drive.google.com/file/d/1Po3cwCLUbqnoDS_6HVnXDBeySXLTgTjv/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 13, 2021',
  //   link: 'https://drive.google.com/file/d/1ssIsfygdu7bo0Ct2FekEzrDN9fxJLfJ9/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Sept. 13, 2021',
  //   link: 'https://drive.google.com/file/d/14r6Kk9N5l6tyPhEiftTtlCJuxCW4tmmN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 21, 2021',
  //   link: 'https://drive.google.com/file/d/1o9sdp11Q9jEBlqFY8JHYqq4MuWeJXoPL/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Sept. 27, 2021',
  //   link: 'https://drive.google.com/file/d/1QvpIk1RqTHXLP2mDopdcl_0HVNnJc-Y1/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 21, 2021',
  //   link: 'https://drive.google.com/file/d/1d6ZkTVYlrNk9NO76DfNjBmWpNwbYPkZr/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 21, 2021',
  //   link: 'https://drive.google.com/file/d/1rMBB4NVzqT_rf4OjE5KAojK-4AKXGsWw/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 9, 2021',
  //   link: 'https://drive.google.com/file/d/1vHzuVRMmQ94bn11Zczkuns_j5vHkYzlr/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/15-Gc2SPyHq6MINEmOnSf1lw2ZGZ8pjg0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | May 4, 2022',
  //   link: 'https://drive.google.com/file/d/13HWZeSMHISmnpERhgBdVo9-Si_5FZ0iT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | June 2, 2022',
  //   link: 'https://drive.google.com/file/d/1P780SLDTcLI4lRHvqIaFPEtKZz0s-vxx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sept. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1UDhWr3pJgzrKxAeximDDN89_jJQxEjJx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1GeAqFvV0MFUYxxbAWXm8So6c0qr-vmGP/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1rMBB4NVzqT_rf4OjE5KAojK-4AKXGsWw/view',
    color: 'success',
  },
];

const leavesProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 11, 2021',
  //   link: 'https://drive.google.com/file/d/1Uu-WCIWzdjllO00SdVsMPK8-ChwHo-Zn/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1Zyza1rpjsR0vFx32lLy0nCO4IxQCus3H/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Feb. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1Mv7-eLpal3u9BgBPlTS6FHVFdR_Xr_yE/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Feb. 18, 2022',
  //   link: 'https://drive.google.com/file/d/1VwrmY0e0RCRUicy3oEjvaafULbkuROMQ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/18dqG61RmK88L7tHvk8dH-bq_49on6yJ9/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1FDMEaaesgkPrkWflKx92Lvp4osKZyELR/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1Sr10-HkLwEqGb4_SwyuRLh9AEeCOAPbS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 28, 2022',
  //   link: 'https://drive.google.com/file/d/1XWgrjBO82ZAIY6XX5FdlU2pzpiCELkPS/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1bAxk1PorsT5i8HGh2XoG-MUsZpNLZk9-/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1rnb6DTqouYLBeZPYwAEF4bZ4vWD_XDyv/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/1g1A-ekvTJ6xIe3aBsOG3pP6RHP8cCkuR/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/18vzvLwgPie26b4hHCIy8tDlBsCLW6lu6/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1OYvzTIPMdYdwzJ6STN29NHkKoZCJxLbw/view?usp=share_link',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/15lctXwcvCtdYfq8RtdQAZ1S6Ghzq8XBH/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/15lctXwcvCtdYfq8RtdQAZ1S6Ghzq8XBH/view',
    color: 'success',
  },
];

const managementAcademicProposals = [
  // {
  //   name: 'Proposal | UC to UAW | July 30, 2021',
  //   link: 'https://drive.google.com/file/d/1nYQNrf35iJC91764mp5D8wjxw4sfz_Mc/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 21, 2021',
  //   link: 'https://drive.google.com/file/d/1ixVD38mnPamzoKXY9-lz39xSKOYSCQ-f/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 22, 2021',
  //   link: 'https://drive.google.com/file/d/1_SQG6X8VHKdQixlqtcGLVkvcj1LNPpkJ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 8, 2021',
  //   link: 'https://drive.google.com/file/d/16faJ0XBwFyJ_VAaiJaGTYqlZ7CSNmeHR/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Feb. 18, 2022',
  //   link: 'https://drive.google.com/file/d/120jms93vmqLqxWGJRVCNZiCNiUOKQRyb/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | May 12, 2022',
  //   link: 'https://drive.google.com/file/d/1Fu14eCzBiMFD2cWSkwsejnnpUKYvpIlq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | November 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | November 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | November 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | November 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1YKs8pPnvuBwbZzfwZCx8mnKvZbjVqYen/view?usp=share_link',
    color: 'success',
  },

];

const medicalSeparationProposals = [];

const noStrikesProposals = [
  // {
  //   name: 'Package | UC to UAW | July 23, 2021',
  //   link: 'https://drive.google.com/file/d/1oX6dD42-Q6mxQTWnXG01FoBwTjlfF8d0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 2, 2021',
  //   link: 'https://drive.google.com/file/d/16ebA1hZwJT-XJnhR074LZmSOgztEk2fn/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Aug. 11, 2021',
  //   link: 'https://drive.google.com/file/d/1vk3pr44NjJHUbiifwJXtu_aa-l7459hg/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | November 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1YKs8pPnvuBwbZzfwZCx8mnKvZbjVqYen/view?usp=share_link',
    color: 'success',
  },
];

const nondiscriminationProposals = [
  {
    name: 'Tentative agreement | Feb. 8, 2022',
    link: 'https://drive.google.com/file/d/14dj7mleOrWNmk03InY5BW_iOLhq8JLEJ/view?usp=sharing',
    color: 'success',
  },
];

const parkingProposals = [
  // {
  //   name: 'Proposal | UC to UAW | July 23, 2021',
  //   link: 'https://drive.google.com/file/d/1B1s4dmS0dMK__QSQgJK3-RV5VWdFXZvH/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 17, 2021',
  //   link: 'https://drive.google.com/file/d/1NDnBNUfsFtzvT8IiNq8TRoRY8YYIK0mM/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Sept. 13, 2021',
  //   link: 'https://drive.google.com/file/d/1hwotME5ek-f-0SPJvNv24hXqPmhvxQbg/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 15, 2021',
  //   link: 'https://drive.google.com/file/d/1OZivbgflDd9X7ccDsra2ZZgnIB0JcxZP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 13, 2021',
  //   link: 'https://drive.google.com/file/d/1yZG9vexq_1TZrucCak2DRv1jDNKHMo8L/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Mar. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1fBRvdsEWinZy5brH8m3QBMrRQHIFUNAn/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | April 29, 2022',
  //   link: 'https://drive.google.com/file/d/1lZPIsRkpSTi5mrstiXIOJk7z3duFoBwj/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 25, 2022',
  //   link: 'https://drive.google.com/file/d/1RPrzVGzTwGGOB2_HcR9S56Y6Lw28viwd/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 28, 2022',
  //   link: 'https://drive.google.com/file/d/1mc70oi7dqGO7rMBu2CKGQBDWUTz_6lz0/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/1uIOOHZHdSkUuikBWlWC49pH7SI8_3GTs/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/18vzvLwgPie26b4hHCIy8tDlBsCLW6lu6/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1DJXaH1JS1ZJ1RwVOUpqAllzjhuDXBl5g/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1BrGkVenip98X4uCMffIyvyBNdkcZMCuL/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 15, 2022',
  //   link: 'https://drive.google.com/file/d/1yfiUkh9i4PwK-eV20R4PvDYLT5ffZKFu/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 15, 2022',
  //   link: 'https://drive.google.com/file/d/1STxVq-NHnUWW79J0GWHRzx7IQ3zGj9qE/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1j6wKeeYOxfpqmZWAdrOInta-xHfC2aKz/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1P1QT-mNwQLrwETHBDAG3dsAsjXrCP1Jp/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1cvRHf_RjS1gGDOLzFmfsZsRQHOe8gtsH/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1_QJ010WJOyrfVEYwqfslVvd7W8oMEdy6/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1mQKtIH8S0nZmXMcQc3uXjf_AI10PLhGB/view?usp=sharing',
    color: 'success',
  },

];

const pastPracticesProposals = [];

const personalTimeOffProposals = [
  {
    name: 'Tentative agreement | Jan. 19, 2022',
    link: 'https://drive.google.com/file/d/14WFHoH3l1aojsnHzmmtFW-ReXBPo5Fmk/view?usp=sharing',
    color: 'success',
  },
];

const personnelProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const postingProposals = [
  {
    name: 'Tentative agreement | Sept. 16, 2021',
    link: 'https://drive.google.com/file/d/1_wBMF50bfWmV6JNuqky5DQgSUIFYcL9_/view?usp=sharing',
    color: 'success',
  },
];

const developmentProposals = [
  {
    name: 'Tentative agreement | Feb. 21, 2021',
    link: 'https://drive.google.com/file/d/1Dw7vvY-2QW2iEtWSy0EVS2sSjFTMRFCG/view?usp=sharing',
    color: 'success',
  },
];

const progressAssessProposals = [
  {
    name: 'Tentative agreement | Feb. 21, 2021',
    link: 'https://drive.google.com/file/d/14r5h7GCVkC42qPcrlIFW2D17PimiVcVw/view?usp=sharing',
    color: 'success',
  },
];

const postdocFellowProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Sept. 9, 2021',
  //   link: 'https://drive.google.com/file/d/1XZ2-Zi-fbetaWunSkUjB4R8McGaMlbGx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/1Yq-tUHAFFRmJJKNrZYNoRq6tyhSsw_pk/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1WN2vo5yWK5aHfF13bkwFN4ouKwhpKXc4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const accommodationProposals = [
  {
    name: 'Tentative agreement | Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1vTYUdcIArk6erGKGz4qcoYZk5dOo6aiQ/view?usp=sharing',
    color: 'success',
  },
];

const reimbursementProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Aug. 25, 2021',
  //   link: 'https://drive.google.com/file/d/1xhuheXIB_yH3lJoQL68y8YnJOTAYDSeQ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 5, 2021',
  //   link: 'https://drive.google.com/file/d/1QGEAZzt3vjK59R9r8sGSoXnxjlZG1LTq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | March 30, 2022',
  //   link: 'https://drive.google.com/file/d/1if6mU22tEfShlQ7ZYX5nv2EQTYR21VyH/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 1, 2022',
  //   link: 'https://drive.google.com/file/d/1WN2vo5yWK5aHfF13bkwFN4ouKwhpKXc4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const respectfulProposals = [
  {
    name: 'Tentative agreement | Sept. 27, 2022',
    link: 'https://drive.google.com/file/d/143IbRBpyHdiBeeuzM1qQjyrDEPmSaRHj/view?usp=sharing',
    color: 'success',
  },
];

const respectResearchProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Sept. 9, 2021',
  //   link: 'https://drive.google.com/file/d/1Ea20EwYMUoe5nDYwTdCE6n64K6zcIm8U/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/1Yq-tUHAFFRmJJKNrZYNoRq6tyhSsw_pk/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Sept. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1UDhWr3pJgzrKxAeximDDN89_jJQxEjJx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const severabilityProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const sickLeaveProposals = [
  {
    name: 'Tentative agreement | Jan. 19, 2022',
    link: 'https://drive.google.com/file/d/1ZVkTsk2aX-F_kiADsaJQNblL4wweF_Oi/view?usp=sharing',
    color: 'success',
  },
];

const successorshipProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const timeProposals = [
  {
    name: 'Tentative agreement | Sept. 16, 2021',
    link: 'https://drive.google.com/file/d/1JNXBaxyxq4BJBTx_57D7nWOidSDgSEEz/view?usp=sharing',
    color: 'success',
  },
];

const titlesProposals = [
  {
    name: 'Tentative agreement | Jan. 19, 2022',
    link: 'https://drive.google.com/file/d/1hZaut74TJ3BmsU7dBu-V-yLNZF8vwPv0/view?usp=sharing',
    color: 'success',
  },
];

const trainingProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const travelProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1agOJCgmuBRmG1I70ZXQhSyFKe0zW5k-A/view?usp=share_link',
    color: 'success',
  },
];

const unionAccessProposals = [
  {
    name: 'Tentative agreement | Feb. 8, 2022',
    link: 'https://drive.google.com/file/d/1r6a1F-qeaeiaWrgOsxZf-mqFW1W1M9su/view?usp=sharing',
    color: 'success',
  },
];

const unionSecurityProposals = [
  {
    name: 'Tentative agreement | Oct. 3, 2022',
    link: 'https://drive.google.com/file/d/1uDfqnhPJks_4bO7NRDZNlnApmk1T8dga/view?usp=sharing',
    color: 'success',
  },
];

const facilitiesProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2022',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const voluntaryResignationProposals = [];

const waiverProposals = [
  {
    name: 'Tentative agreement | Feb. 21, 2022',
    link: 'https://drive.google.com/file/d/1Ja3WA9LR5H2nYRfdkf6uxaLD3Q0b2JPd/view?usp=sharing',
    color: 'success',
  },
];

const workAuthProposals = [
  // {
  //   name: 'Proposal | UC to UAW | Aug. 25, 2021',
  //   link: 'https://drive.google.com/file/d/1Lq0RLGYIWGZAcn5N43sZLp9RooChF-V5/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 13, 2021',
  //   link: 'https://drive.google.com/file/d/1BBU8uUW7F5-evNZNe-dsWmm-wehahRpM/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 13, 2021',
  //   link: 'https://drive.google.com/file/d/1n-rM0oNDEKKe2cINOu_IqHq2XfLGG6WA/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 15, 2021',
  //   link: 'https://drive.google.com/file/d/15-Gc2SPyHq6MINEmOnSf1lw2ZGZ8pjg0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Jan. 7, 2022',
  //   link: 'https://drive.google.com/file/d/13OxGg7s8RgCH_yempMfd6GioisD2CyJY/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Feb. 15, 2022',
  //   link: 'https://drive.google.com/file/d/1JUYEeeHTBNnpqekyyh6dnd8ONRXyY5ik/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | May. 4, 2022',
  //   link: 'https://drive.google.com/file/d/1leOZz8BegnCF0lOsdHUjDVVMB6uACUYX/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | June 2, 2022',
  //   link: 'https://drive.google.com/file/d/1P780SLDTcLI4lRHvqIaFPEtKZz0s-vxx/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 25, 2022',
  //   link: 'https://drive.google.com/file/d/1RPrzVGzTwGGOB2_HcR9S56Y6Lw28viwd/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Sept. 14, 2022',
  //   link: 'https://drive.google.com/file/d/1EG_eQrq-QHyTC2pXqVVBVX-RvJ8QP-m3/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 11, 2022',
  //   link: 'https://drive.google.com/file/d/1GeAqFvV0MFUYxxbAWXm8So6c0qr-vmGP/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1apk9KZyph3kN_olbYevfQdNiF6u3i7G4/view?usp=share_link',
  //   color: 'secondary',
  // },

  // {
  //   name: 'Package | UAW to UC | Nov. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1lWIIE6qKMxJrR2vgWtjs28jVT3Fjm9qh/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1M_N2HWjuWYexxfbXeVGi1Z89qRwz5COr/view?usp=sharing',
    color: 'success',
  },
];

const injuriesProposals = [
  {
    name: 'Tentative agreement | Sept. 16, 2021',
    link: 'https://drive.google.com/file/d/1f8dFtmruNHtqNFDTAMOi1r2P9xJVXOuI/view?usp=sharing',
    color: 'success',
  },
];

const workspaceProposals = [
  {
    name: 'Tentative agreement | Aug. 1, 2021',
    link: 'https://drive.google.com/file/d/1EFVNTQnpeFA-buWZaq9QG73kdGn2jzrs/view',
    color: 'success',
  },
];

const durationProposals = [
  // {
  //   name: 'Proposal | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/1wqOX2oF_WfPfnBrOGAsxjpdYMyGuPMnE/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/15zA4XPiNK7_CgTMFUPuPztbeGxqosQN_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 3, 2022',
  //   link: 'https://drive.google.com/file/d/1WN2vo5yWK5aHfF13bkwFN4ouKwhpKXc4/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 13, 2022',
  //   link: 'https://drive.google.com/file/d/1vDnBFZSbohW7EpB2fA47jV7zs8N0E8Lm/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1jWaIjii94vxdMsK5AV0ai-9MZTFm_r1_/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Tentative agreement | Nov. 27, 2022',
  //   link: 'https://drive.google.com/file/d/1_IRlQMYTu31_qkuBeSVSPAPiR8sWpkG_/view?usp=share_link',
  //   color: 'success',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1YJ2zI4_Kyz0RGRHO0E9pTZKwGNoiL-WA/view?usp=sharing',
    color: 'success',
  },

];

const healthBenefitsProposals = [
  {
    name: 'Tentative agreement | Nov. 17, 2022',
    link: 'https://drive.google.com/file/d/1_IRlQMYTu31_qkuBeSVSPAPiR8sWpkG_/view?usp=share_link',
    color: 'success',
  },
];

const compLetter = [
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1OBSm8SM7ZAE5IGg_fCnWEeRdOCAxl_6L/view?usp=sharing',
    color: 'success',
  },
  // {
  //   name: 'Package | UC to UAW | Sept. 27, 2022',
  //   link: 'https://drive.google.com/file/d/1hzxQ_7vNSUVn26kUMYCfLXdsRq-kDMl4/view',
  //   color: 'secondary',
  // },
];

const transitLetter = [
];

const jlmcLetter = [
  {
    name: 'Tentative agreement | Oct. 24, 2022',
    link: 'https://drive.google.com/file/d/1ay0pC-0pIWt-iIAcf1SpbA6VoAP1Ggyq/view?usp=sharing',
    color: 'success',
  },
];

const appendixAProposals = [
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1OoanhUhz-SrfbZq7-zY4GkTUhXeNmWPF/view?usp=sharing',
    color: 'success',
  },
];

const appendixBProposals = [
  {
    name: 'Tentative agreement | Nov. 22, 2022',
    link: 'https://drive.google.com/file/d/1lagV0Vg56XJwrnRuQnm0VPHCfDX6IuA4/view?usp=share_link',
    color: 'success',
  },
];

const appendixCProposals = [
  {
    name: 'Tentative agreement | Oct. 3, 2022',
    link: 'https://drive.google.com/file/d/1R24EDevPVnTbSq_-7ZkTmuNN9CpVxrXA/view?usp=sharing',
    color: 'success',
  },
];

const appendixFProposals = [
  {
    name: 'Tentative agreement | July 14, 2022',
    link: 'https://drive.google.com/file/d/12ZGAP8-7YguTu41NG0q1-Mod6nIFLPoF/view?usp=sharing',
    color: 'success',
  },
];

const appendixGProposals = [
  // {
  //   name: 'Proposal | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/1tqCDTKtR-tCLMU0KNW8Ikr6cBXTERBUl/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 9, 2022',
  //   link: 'https://drive.google.com/file/d/13ZhLo8WbB_JH9NG9dAez46i_812s1RvB/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 23, 2022',
  //   link: 'https://drive.google.com/file/d/1uPpq3EFm3a-_N7vzb6Q8_dYwdKnJLzZj/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1ewwUMH4qY_M0zxzHiXUIS3vYXhy44VOC/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1-eSPkf56pgun1cGXyEfqOVVtXj4xqhK5/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1YgHxrVKsdRqOziBU5K9GwyOlmrXRvQbm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1yhAc67picvmdHzD8dhMhfY4k1R2sLIz7/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1KBS_kRRrmTIsL2bhV8iA4MN43b--h3im/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 28, 2022',
    link: 'https://drive.google.com/file/d/1yhAc67picvmdHzD8dhMhfY4k1R2sLIz7/view',
    color: 'success',
  },

];

const appendixHProposals = [{
  name: 'Tentative agreement | Nov. 28, 2022',
  link: 'https://drive.google.com/file/d/1B5MfqDnB1ng-OjMRnSbFOnsuS_JatCyF/view?usp=sharing',
  color: 'success',
}];

const groundRulesProposals = [
  {
    name: 'Tentative agreement | Aug. 11, 2021',
    link: 'https://drive.google.com/file/d/1Zfg4dj1awQkPHfoN-gsDr_gSBm-jOmBK/view?usp=sharing',
    color: 'success',
  },
];

const extensionProposals = [
  {
    name: 'Extension of previous contract to Oct. 31, 2022',
    link: 'https://drive.google.com/file/d/1zGA2poRjeQL63syfCMYf-4R_yZztTex4/view?usp=sharing',
    color: 'secondary',
  },
];

export const infoPostdocs = {

  Recognition: {

    proposals: recognitionProposals,
    intro: 'A tentative agreement on the recognition article was reached in August 2021 as part of a package of proposals. The package agreement maintained the language of eight articles from the previous contract between the UAW Local 5810 and the UC system.',

  },
  Appointments: {

    proposals: appointmentsProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract.',

  },
  Benefits: {

    proposals: benefitsProposals,
    intro: 'The Nov. 17, 2021 tentative agreement outlines postdocs’ participation in several benefits programs by the UC. It includes the Postdoctoral Scholar Benefit Plans medical, dental and vision plans, among others.',

  },
  'Child care': {

    proposals: childCareProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract.',

  },
  Compensation: {

    proposals: compensationProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract. However, the complete proposal history for this article is attached.',

  },
  'Discipline and dismissal': {

    proposals: disciplineProposals,
    intro: 'A tentative agreement on discipline and dismissal was reached Sept. 16, 2021.',

  },
  'Grievance and arbitration procedures': {

    proposals: grievanceProposals,
    intro: 'On Sept. 27, 2022, parties tentatively agreed on procedures for grievances and arbitrations.',

  },
  'Health and safety': {

    proposals: healthSafetyProposals,
    intro: 'UAW Local 5810 and the UC system tentatively agreed to language for this article Oct. 21, 2021. The union and the UC system acknowledge that it is both parties’ responsibility to maintain safe and healthy workplaces — which includes those in laboratory settings.',

  },
  Housing: {

    proposals: housingProposals,
    intro: 'This article was withdrawn as part of a Nov. 28, 2022 package deal.',

  },
  Holidays: {

    proposals: holidaysProposals,
    intro: 'A tentative agreement on time off for designated holidays was reached Aug. 1, 2021.',

  },
  Immigration: {

    proposals: immigrationProposals,
    intro: 'Both parties tentatively agreed to language on the immigration article Nov. 18, 2022, but the language has not yet been provided.',

  },
  'Individual development plans and progress assessments': {

    proposals: individualDevelopmentProposals,
    intro: 'The union and the UC system reached a tentative agreement on this article Feb. 21, 2022.',

  },
  'International scholar and immigrant support': {

    proposals: internationalScholarProposals,
    intro: 'This article was withdrawn as part of a package proposal Nov. 28, 2022.',

  },
  'Job abandonment': {

    proposals: jobAbandonmentProposals,
    intro: 'The UC system withdrew its job abandonment proposal Sept. 21, 2021.',

  },
  'Labor management meetings': {

    proposals: laborManagementProposals,
    intro: 'Both parties came to a tentative agreement on labor management meetings in August 2021 as part of a package that maintained the language of eight articles from their previous contract.',

  },
  'Lawrence Berkeley National Lab article': {

    proposals: LBNLProposals,
    intro: 'The Nov. 22, 2022 tentative agreement on this article details some policies for postdocs working in the Lawrence Berkeley National Lab – including holidays, compensation and personal time off.',

  },
  Layoff: {

    proposals: layoffProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract, moving forward on an Oct. 21, 2021 UC system proposal.',

  },
  'Leaves of absence': {

    proposals: leavesProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract, moving forward on a Nov. 23, 2022 UC system proposal.',

  },
  'Management and academic rights': {

    proposals: managementAcademicProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract, moving forward on a May 12, 2022 UC system proposal.',

  },
  'Medical separation': {

    proposals: medicalSeparationProposals,
    intro: 'Medical separation occurs when a postdoc is unable to perform the essential function of their position due to their disability, according to the UC system\'s original Aug. 17, 2021 proposal for the article. The UC system withdrew its proposal for this new article March 3, 2022.',

  },
  'No strikes': {

    proposals: noStrikesProposals,
    intro: 'The UC system’s original July 23, 2021, proposal for this article sought to maintain the previous contract’s no strikes article, which prohibited striking. On Nov. 28, 2022, the parties tentatively agreed on this article\'s previous contract language.',

  },
  Nondiscrimination: {

    proposals: nondiscriminationProposals,
    intro: 'The parties reached a tentative agreement on nondiscrimination in the workplace Feb. 8, 2022.',

  },
  'Parking and transit': {

    proposals: parkingProposals,
    intro: 'After more than 20 packages and proposals, the UC system and UAW Local 5810 came to a tentative agreement on this portion of the contract Nov. 28, 2022.',
  },
  'Past practices': {

    proposals: pastPracticesProposals,
    intro: 'As part of a Feb. 18, 2022, package of proposals, the union withdrew their proposal for a new past practice article.',
  },
  'Personal time off': {

    proposals: personalTimeOffProposals,
    intro: 'Both parties tentatively agreed upon a policy for personal time off Jan. 19, 2022. Now, postdocs should get 24 paid days of personal time off for each year-long appointment, but using them requires approval from the UC system.',
  },
  'Personnel files': {

    proposals: personnelProposals,
    intro: 'Personnel files refer to information about postdocs’ appointment with the UC system. On Aug. 1, 2021, the union and the UC system tentatively agreed to maintain their previous contract’s article on personnel files.',
  },
  Posting: {

    proposals: postingProposals,
    intro: 'The UC system and the UAW Local 5810 have reached a tentative agreement maintaining the status quo. Posting policies — regarding job offers and equivalent compensation — will not change from the last contract, but campuses may expand upon them if they so choose.',
  },
  'Professional development and career counseling': {

    proposals: developmentProposals,
    intro: 'A tentative agreement was reached after more than 15 proposals and packages. Under the agreement, the UC system should offer career counseling, writing workshops and international scholar workshops for its postdocs.',
  },
  'Progress assessments': {

    proposals: progressAssessProposals,
    intro: 'Both parties reached a tentative agreement Feb. 21, 2022.',
  },
  'President\'s postdoctoral fellowships': {

    proposals: postdocFellowProposals,
    intro: 'This article was withdrawn as part of a package deal Nov. 28, 2022.',
  },
  'Reasonable accommodation': {

    proposals: accommodationProposals,
    intro: 'On Oct. 31, 2022, a tentative agreement regarding disability accommodations and work adjustments was reached. This was achieved after almost 20 back-and-forth proposals and packages.',
  },
  'Relocation reimbursement': {

    proposals: reimbursementProposals,
    intro: 'Proposals from the UAW Local 5810 have asked the UC system to reimburse long-term work relocation expenses, such as rent, airfare and visa fees. According to a Nov. 28, 2022 tentative agreement on a package, the union withdrew the article.',
  },
  'Respectful work environment': {

    proposals: respectfulProposals,
    intro: 'A tentative agreement was reached Sept. 27, 2022, defining what is and is not abusive conduct.',
  },
  'Respect is a part of research training': {

    proposals: respectResearchProposals,
    intro: 'The union’s first proposal for this new article would mandate in-person sexual harrasment prevention and response workshops for newly employed postdocs. By a Nov. 28, 2022 tentative agreement on a package proposal, the UAW Local 5810 withdrew the article.',
  },
  Severability: {

    proposals: severabilityProposals,
    intro: 'Both parties reached a tentative agreement not to change the previous contract language for this article — along with seven others — Aug. 1, 2021.',
  },
  'Sick leave': {

    proposals: sickLeaveProposals,
    intro: 'Provisions for sick leave to care for family members now include grandparents, grandchildren and siblings, according to the Jan. 18, 2022, tentative agreement.',
  },
  Successorship: {

    proposals: successorshipProposals,
    intro: 'As part of an Aug. 1, 2021, tentative agreement, the UAW Local 5810 and the UC system agreed to maintain the previous contract language for this article and seven others.',
  },
  'Time and effort commitment': {

    proposals: timeProposals,
    intro: 'After two proposals, a tentative agreement was reached Sept. 16, 2021. Like their previous contract, time spent during meals and commuting to work are not counted as working hours.',
  },
  'Titles and classifications': {

    proposals: titlesProposals,
    intro: 'On Jan. 19, 2022, a tentative agreement was reached between the UC system and UAW Local 5810. The new article removes special classifications for postdocs working at Lawrence Berkeley National Lab, abbreviated as LBL on the contract.',
  },
  Training: {

    proposals: trainingProposals,
    intro: 'The tentative agreement reached August 1, 2021, includes training among the articles that will not be changed from previous contract language.',
  },
  'Travel reimbursement': {

    proposals: travelProposals,
    intro: 'On Oct, 21, 2021, parties tentatively agreed on a proposal for this article, according to the union’s postdoc bargaining tracking Google Sheet. However, a link to the agreement was not provided.',
  },
  'Union access and rights': {

    proposals: unionAccessProposals,
    intro: 'By a Feb. 8, 2022 tentative agreement, each UC campus should conduct a monthly, campuswide orientation for new postdocs.',
  },
  'Union security': {

    proposals: unionSecurityProposals,
    intro: 'The UC system and the UAW Local 5810 tentatively established policies on union security Oct. 3, 2022. Among its many guidelines, it required the UC system to send postdocs a form for union membership along with Appendix YY.',
  },
  'University facilities and services': {

    proposals: facilitiesProposals,
    intro: 'Under an Aug. 1, 2021 tentative agreement, this article and seven others will not change from previous contract language.',
  },
  'Voluntary resignation': {

    proposals: voluntaryResignationProposals,
    intro: 'This new article proposed by the UC system would have established the conditions for postdocs’ voluntary resignations. However, it was withdrawn, according to the UAW Local 5810.',
  },
  Waiver: {

    proposals: waiverProposals,
    intro: 'A tentative agreement on the waiver article was reached Feb. 21, 2022. It acknowledges that both parties have been free to collectively bargain during these contract negotiations.',
  },
  'Work authorization': {

    proposals: workAuthProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on a UC system proposal from Jan. 7, 2022.',
  },
  'Work-incurred injury and illness': {

    proposals: injuriesProposals,
    intro: 'The Sept. 13, 2022 tentative agreement between both parties changed little from the original contract, save for a pronoun update.',
  },
  'Workspace and materials': {

    proposals: workspaceProposals,
    intro: 'This was the final proposal included in the Aug. 1, 2022, tentative agreement package between the UC system and UAW Local 5810. The original contract language is not slated to change.',
  },
  Duration: {

    proposals: durationProposals,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 tentatively agreed that this contract should be in effect until Sept. 30, 2027.',
  },
  'Health benefits side letter': {

    proposals: healthBenefitsProposals,
    intro: 'The Nov. 17, 2022 tentative agreement requires the UC system to include partial coverage for infertility treatments.',
  },
  'Compensation side letter': {

    proposals: compLetter,
    intro: 'On Nov. 28, 2022, the UC system and UAW Local 5810 came to a tentative agreement on this side letter.',
  },
  'Transit side letter': {

    proposals: transitLetter,
    intro: 'According to UAW Local 5810, this article was withdrawn.',
  },
  'Joint labor management committee side letter': {

    proposals: jlmcLetter,
    intro: 'This side letter, which details agenda items for a joint labor management committee, was tentatively agreed upon Oct. 28, 2022.',
  },
  'Appendix A': {

    proposals: appendixAProposals,
    intro: 'With some updates, parties will maintain their previous contract language for this appendix, according to a Nov. 28, 2022 tentative agreement on a package.',
  },
  'Appendix B': {

    proposals: appendixBProposals,
    intro: 'This Nov. 22, 2022, tentative agreement mirrors the UC system\'s June 9, 2022, proposal for Appendix B.',
  },
  'Appendix C': {

    proposals: appendixCProposals,
    intro: 'The membership election form allows postdocs to opt into union membership. The form is sent through Appendix C, which looks like an email template. A tentative agreement for the appendix was reached by both parties Oct. 3, 2022.',
  },
  'Appendix F': {

    proposals: appendixFProposals,
    intro: 'A finalized panel of arbitrators, written out in Appendix F, was tentatively agreed upon July 14, 2022.',
  },
  'Appendix G': {

    proposals: appendixGProposals,
    intro: 'By a Nov. 28, 2022 tentative agreement, Appendix G contains required information for a postdoc’s appointment letter. It mirrors an Oct. 12, 2022 proposal from the union.',
  },
  'Appendix H': {
    proposals: appendixHProposals,
    intro: 'Parties tentatively agreed upon the contract language for Appendix H, which concerns parking rates.',
  },
  'Ground rules': {

    proposals: groundRulesProposals,
    intro: 'The ground rules for bargaining negotiations were tentatively agreed upon by both parties Aug. 11, 2021.',
  },
  'Extension of previous contract': {

    proposals: extensionProposals,
    intro: 'The previous AR contact between the UC system and the UAW Local 5810 was originally slated to be in effect until Sept. 30, 2020. That contract barred the union from authorizing strikes that interfere with the UC system’s operations. It was only extended to Oct. 31, 2022.',
  },
};
